// export const CU24URL = "https://cu24hsv2.cu.coop.py/"
// export const oauth = "https://cu24hsv2.cu.coop.py/api/oauth/"
// export const oauthOld = "https://cu24hsv2.cu.coop.py/api/oauth-old/"
// export const personas = "https://cu24hsv2.cu.coop.py/api/personas/"
// export const compromisoSocio = "https://cu24hsv2.cu.coop.py/api/compromisos-socio/"
// export const consultasAPI = "https://cu24hsv2.cu.coop.py/api/consultas/"
// export const cuentas = "https://cu24hsv2.cu.coop.py/api/cuentas/"
// export const creditos = "https://cu24hsv2.cu.coop.py/api/creditos/"
// export const tarjetas = "https://cu24hsv2.cu.coop.py/api/tarjetas/"
// export const ruedas = "https://cu24hsv2.cu.coop.py/api/ruedas/"
// export const notificaciones = "https://cu24hsv2.cu.coop.py/api/notificaciones/"
// export const comprobantes = "https://cu24hsv2.cu.coop.py/api/comprobantes/"
// export const solicitudes = "https://cu24hsv2.cu.coop.py/api/solicitudes/"
// export const transferencias = "https://cu24hsv2.cu.coop.py/api/transferencias/"
// export const pronetPagos = "https://cu24hsv2.cu.coop.py/api/pronet-pagos/"
// export const basaSipacoop = "https://cu24hsv2.cu.coop.py/api/basa-sipacoop/"

// export const CU24URL = "https://cu24hs.cu.coop.py/"
// export const oauth = "https://cu24hs-dev.universitaria.coop/api/desa/oauth/"
// export const oauthOld = "http://cu24-oauth-old-cu24hs-dev.apps.cloud.universitaria.coop/"
// export const configuraciones = "https://cu24hs-dev.universitaria.coop/api/desa/configuraciones/"
// export const personas = "https://cu24hs-dev.universitaria.coop/api/desa/personas/"
// export const compromisoSocio = "https://cu24hs-dev.universitaria.coop/api/desa/compromisos-socio/"
// export const consultasAPI = "https://cu24hs-dev.universitaria.coop/api/desa/consultas/"
// export const cuentas = "https://cu24hs-dev.universitaria.coop/api/desa/cuentas/"
// export const creditos = "https://cu24hs-dev.universitaria.coop/api/desa/creditos/"
// export const tarjetas = "https://cu24hs-dev.universitaria.coop/api/desa/tarjetas/"
// export const ruedas = "https://cu24hs-dev.universitaria.coop/api/desa/ruedas/"
// export const notificaciones = "https://cu24hs-dev.universitaria.coop/api/desa/notificaciones/"
// export const solicitudes = "https://cu24hs-dev.universitaria.coop/api/desa/solicitudes/"
// export const comprobantes = "https://cu24hs-dev.universitaria.coop/api/desa/comprobantes/"
// export const pronetPagos = "https://cu24hs-dev.universitaria.coop/api/desa/pronet-pagos/"
// export const basaSipacoop = "https://cu24hs-dev.universitaria.coop/api/desa/basa-sipacoop/"
// export const transferencias = "https://cu24hs-dev.universitaria.coop/api/desa/transferencias/"
// export const dimo = "https://cu24hs-dev.universitaria.coop/api/desa/cabal-dimo/"
// export const convenios = "https://cu24hs-dev.universitaria.coop/api/desa/convenios/"
// export const conveniosImg = "https://cu24hs-dev.universitaria.coop/api/desa/convenios-ftp/"
// export const sugerencias = "https://cu24hs-dev.universitaria.coop/api/desa/sugerencias/"
// export const cardInformer = "https://cu24hs-dev.universitaria.coop/api/desa/bancard-card-informer/"
// export const entrust = "https://cu24hs-dev.universitaria.coop/api/desa/entrust/"
// export const pinVirtual = "https://cu24hs-dev.universitaria.coop/api/desa/pin-virtual/"
// export const infonetUrl = "https://pinpad.infonet.com.py:4444/vpinpad/#"
// export const cuentasSocio = "https://cu24hs-dev.universitaria.coop/api/desa/cuentas/"
// export const plazosPrestamoInmediato="https://cu24hs-dev.universitaria.coop/api/desa/creditos/"
// export const pagoPix= "https://cu24hs-dev.universitaria.coop/api/desa/pix"


export const CU24URL = process.env.REACT_APP_CU24_URL
export const oauth = process.env.REACT_APP_OAUTH_URL
export const oauthOld = process.env.REACT_APP_OAUTH_OLD_URL
export const configuraciones = process.env.REACT_APP_CONFIGURACIONES_URL
export const personas = process.env.REACT_APP_PERSONAS_URL
export const compromisoSocio = process.env.REACT_APP_COMPROMISO_SOCIO_URL
export const consultasAPI = process.env.REACT_APP_CONSULTAS_API_URL
export const cuentas = process.env.REACT_APP_CUENTAS_URL
export const creditos = process.env.REACT_APP_CREDITOS_URL
export const tarjetas = process.env.REACT_APP_TARJETAS_URL
export const ruedas = process.env.REACT_APP_RUEDAS_URL
export const notificaciones = process.env.REACT_APP_NOTIFICACIONES_URL
export const solicitudes = process.env.REACT_APP_SOLICITUDES_URL
export const comprobantes = process.env.REACT_APP_COMPROBANTES_URL
export const pronetPagos = process.env.REACT_APP_PRONET_PAGOS_URL
export const basaSipacoop = process.env.REACT_APP_BASA_SIPACOOP_URL
export const transferencias = process.env.REACT_APP_TRANSFERENCIAS_URL
export const dimo = process.env.REACT_APP_DIMO_URL
export const convenios = process.env.REACT_APP_CONVENIOS_URL
export const conveniosImg = process.env.REACT_APP_CONVENIOS_IMG_URL
export const sugerencias = process.env.REACT_APP_SUGERENCIAS_URL
export const cardInformer = process.env.REACT_APP_CARD_INFORMER_URL
export const entrust = process.env.REACT_APP_ENTRUST_URL
export const pinVirtual = "https://cu24hs.universitaria.coop/api/pin-virtual/"
export const infonetUrl = process.env.REACT_APP_INFONET_URL
export const pagoPix = process.env.REACT_APP_PIX
